import React, { useEffect, useState } from "react";

const CompanyLogo = ({ width = "150px", height = "40px" }) => {
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    try {
      const settingsStr = localStorage.getItem("settings");

      if (
        settingsStr &&
        settingsStr !== "undefined" &&
        settingsStr !== "null"
      ) {
        const settings = JSON.parse(settingsStr);
        if (settings?.icon) {
          setLogoUrl(settings.icon);
          
        }


      }
    } catch (err) {
      console.error("Failed to load company logo:", err);
    }
  }, []);
console.log('logourl',logoUrl)
  if (!logoUrl) return null;
  return (
    <img
      src={logoUrl}
      alt="Company Logo"
      style={{
        width,
        height,
        objectFit: "contain",
        display: "block",
      }}
    />
  );
  
};

export default CompanyLogo;
